import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 查询当前用户的工作区列表
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function listWorkspaces() {
  return request('GET', '/api/v1/workspaces')
}
